module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch15"
    }
  }, [_c('b', [_vm._v("Transportation")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("On average, a commercial airplane in the United States gets struck by lightning at least once a year.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first car manufacturer to introduce seat belts: Saab, in 1958.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("China’s Shanghai Maglev Train is the world’s fastest passenger train. It reaches speeds of more than 250 mph.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("There are about 600 million passenger cars in the world, one for every 11 people.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First monorail in the United States: the Disneyland Monorail System, which opened in 1959.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Motorola’s first products were car radios. The company’s name is a combination of “motor” and “Victrola.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Germany was the first nation to develop rocket-powered aircraft, during World War II.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First member of the British royal family to fly in a jet: the Queen Mother, in 1952.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The word “train” comes from the Latin "), _c('i', [_vm._v("trahere")]), _vm._v(", meaning to pull or draw.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Very early automobile models didn’t have steering wheels. Drivers used a lever to control the car’s direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first commercial jet—the de Havilland Comet—made its inaugural flight in 1952.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first flying device: the Pigeon, invented around 400 BC, looked like a bird and was propelled by steam.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("World’s steepest railroad: Switzerland’s Pilatus Railway. It climbs 7,000 feet to the top of Mt. Pilatus at a grade of 48 percent.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Most car horns in the United States beep in the key of F.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6f4b3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter15.vue
// module id = 117
// module chunks = 0